<script setup lang="ts">
// Вход. Узел рассказывает о себе до входа: название и оформление видны сразу, а не после успешной
// попытки — человек должен понимать, куда он входит.
import { onMounted, ref } from "vue";

import { useSession } from "../stores/session.ts";

const session = useSession();
const login = ref("");
const password = ref("");

onMounted(() => void session.loadNode());

async function submit(): Promise<void> {
  await session.login(login.value, password.value);
}
</script>

<template>
  <div class="y-center">
    <form class="y-auth y-stack" @submit.prevent="submit">
      <div>
        <div class="y-auth-title">{{ session.node?.displayName || "Yofis" }}</div>
        <div class="y-auth-sub">{{ session.node?.domain }}</div>
      </div>
      <label class="y-field">
        <input v-model="login" class="y-input" name="login" autocomplete="username" placeholder="Логин или адрес">
      </label>
      <label class="y-field">
        <input v-model="password" class="y-input" name="password" type="password" autocomplete="current-password" placeholder="Пароль">
      </label>
      <div v-if="session.error" class="y-auth-err">{{ session.error }}</div>
      <button class="y-btn primary lg" type="submit" :disabled="session.busy">
        {{ session.busy ? "Входим…" : "Войти" }}
      </button>
    </form>
  </div>
</template>
